"use client";

import type { ReactNode } from "react";
import { Header } from "@/components/design/layout/Header";
import { Footer } from "@/components/design/layout/Footer";
import {
    RegistrationProgressBar,
    resolveRegistrationProgressStep,
} from "@/components/design/registration/RegistrationProgressBar";
import { useFestRegistrationBookingSync } from "@/hooks/useFestRegistrationBookingSync";
import { usePathname } from "@/i18n/navigation";
import { WhatsAppSupportFab } from "@/components/design/shared/WhatsAppSupportFab";

type Props = {
    children: ReactNode;
};

/** `useFestRegistrationBookingSync`: на каждой странице воронки — `/profile/me`, затем GET participants. */
export function FestRegistrationLayoutClient({ children }: Props) {
    const pathname = usePathname() || "/";
    const currentStep = resolveRegistrationProgressStep(pathname);
    useFestRegistrationBookingSync();

    return (
        <div className="flex min-h-0 flex-1 flex-col pt-16 md:pt-20">
            <Header />
            <RegistrationProgressBar currentStep={currentStep} />
            <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-x-clip">
                {children}
            </div>
            <Footer />

            <WhatsAppSupportFab />
        </div>
    );
}
